import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingHeart, faFileInvoiceDollar, faCog } from "@fortawesome/free-solid-svg-icons";

function Home() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <Container>
        <div className="text-center mb-5">
          <h1 className="fw-bold text-warning mb-3" style={{ fontSize: 'clamp(1.75rem, 6vw, 2.75rem)', textShadow: '0 4px 12px rgba(0,0,0,0.5)' }}>
            ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
          </h1>
          <p className="text-light opacity-75 fw-light mb-0" style={{ fontSize: 'clamp(1rem, 4vw, 1.25rem)', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
            <span className="fw-bold text-white">ஈஞ்சார்</span>, சிவகாசி மேற்கு, விருதுநகர் மாவட்டம் - 626124
          </p>
        </div>

        <h4 className="fw-bold text-white text-center mt-4 mb-3 border-bottom border-secondary pb-2" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
          சிவன்ராத்திரி {new Date().getFullYear()}
        </h4>

        <Row className="justify-content-center g-3 mt-1">
          <Col md={6} lg={4} sm={12} xs={12}>
            <Link to="/donation/bill" className="text-decoration-none">
              <Card className="h-100 p-3 border-0 rounded-4 shadow-sm bg-white">
                <Card.Body className="d-flex align-items-center p-1">
                  <FontAwesomeIcon icon={faHandHoldingHeart} size="2x" className="text-warning me-3" />
                  <div className="text-start">
                    <Card.Title className="fw-bold text-dark fs-5 mb-0">Donation / நன்கொடை</Card.Title>
                    <Card.Text className="text-muted mt-1 d-none d-md-block" style={{fontSize: '0.85rem'}}>
                      Manage and create new donation receipts.
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col md={6} lg={4} sm={12} xs={12}>
            <Link to="/tax/bill" className="text-decoration-none">
              <Card className="h-100 p-3 border-0 rounded-4 shadow-sm bg-white">
                <Card.Body className="d-flex align-items-center p-1">
                  <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" className="text-success me-3" />
                  <div className="text-start">
                    <Card.Title className="fw-bold text-dark fs-5 mb-0">Tax / வரி</Card.Title>
                    <Card.Text className="text-muted mt-1 d-none d-md-block" style={{fontSize: '0.85rem'}}>
                      Manage and collect temple taxes.
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>

        <h4 className="fw-bold text-white text-center mt-5 mb-3 border-bottom border-secondary pb-2" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
          கும்பாபிஷேகம் சிறப்பு வசூல்
        </h4>
        
        <Row className="justify-content-center g-3 mt-1 mb-4">
          <Col md={6} lg={4} sm={12} xs={12}>
            <Link to="/kumba/donation/bill" className="text-decoration-none">
              <Card className="h-100 p-3 border-0 rounded-4 shadow-sm bg-white">
                <Card.Body className="d-flex align-items-center p-1">
                  <FontAwesomeIcon icon={faHandHoldingHeart} size="2x" className="text-danger me-3" />
                  <div className="text-start">
                    <Card.Title className="fw-bold text-dark fs-5 mb-0">கும்பாபிஷேக நன்கொடை</Card.Title>
                    <Card.Text className="text-muted mt-1 d-none d-md-block" style={{fontSize: '0.85rem'}}>
                      Manage Kumbaabishegam donation receipts.
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col md={6} lg={4} sm={12} xs={12}>
            <Link to="/kumba/tax/bill" className="text-decoration-none">
              <Card className="h-100 p-3 border-0 rounded-4 shadow-sm bg-white">
                <Card.Body className="d-flex align-items-center p-1">
                  <FontAwesomeIcon icon={faFileInvoiceDollar} size="2x" className="text-primary me-3" />
                  <div className="text-start">
                    <Card.Title className="fw-bold text-dark fs-5 mb-0">கும்பாபிஷேக வரி</Card.Title>
                    <Card.Text className="text-muted mt-1 d-none d-md-block" style={{fontSize: '0.85rem'}}>
                      Manage Kumbaabishegam temple taxes.
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
